import React from 'react';
import PropTypes from 'prop-types';
import Box from '@tds/core-box';
import Text from '@tds/core-text';

const SelectedProducts = ({ products, label }) => {
  return (
    <Box>
      <Text bold color="#4B286D">
        {label}:{' '}
      </Text>
      {products && products.length > 0 ? (
        products.map((product, i) => (
          <Text>
            {product}
            {i < products.length - 1 ? ', ' : ''}
          </Text>
        ))
      ) : (
        <Text>Nothing selected</Text>
      )}
    </Box>
  );
};

SelectedProducts.propTypes = {
  products: PropTypes.arrayOf(PropTypes.string).isRequired,
  label: PropTypes.string
};

SelectedProducts.defaultProps = {
  label: 'Products'
};

export default SelectedProducts;
